export type CheckIndicatorStatus = "empty" | "valid" | "invalid";

type CheckIndicatorProps = {
  status?: CheckIndicatorStatus;
};

export default function CheckIndicator({ status = "empty" }: CheckIndicatorProps) {
  let fill = "#F5F6F8";
  let stroke = "#979AA0";

  if (status === "valid") {
    fill = "#E9F8F1";
    stroke = "#1C8352";
  } else if (status === "invalid") {
    fill = "#FFECEB";
    stroke = "#B53129";
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M18.3333 10.0001C18.3333 14.6025 14.6023 18.3334 9.99996 18.3334C5.39759 18.3334 1.66663 14.6025 1.66663 10.0001C1.66663 5.39771 5.39759 1.66675 9.99996 1.66675C14.6023 1.66675 18.3333 5.39771 18.3333 10.0001Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="1.39167"
        strokeLinecap="round"
      />
      {/* Only show check for valid or empty */}
      {(status === "valid" || status === "empty") && (
        <path
          d="M13.3333 8.33341L9.03024 12.2453C8.87131 12.3898 8.6286 12.3898 8.46968 12.2453L6.66663 10.6061"
          stroke={stroke}
          strokeWidth="1.39167"
          strokeLinecap="round"
        />
      )}
      {status === "invalid" && (
        <text
          x="10"
          y="14"
          textAnchor="middle"
          fontSize="11"
          fontWeight="bold"
          fill="#B53129"
          fontFamily="inherit"
        >
          !
        </text>
      )}
    </svg>
  );
}
